<template>
  <v-card-text>
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex align-center ga-1">
        <span class="text-disabled font-size-14">Призначено виконавців:</span>
        <b>{{ executors.length }}</b>
      </div>

      <v-btn
        v-if="canCreateIncidentExecutor"
        :loading="$loading.isLoading('incidentExecutorCreate')"
        color="black"
        rounded="lg"
        @click="openIncidentExecutorDialog">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span>Додати виконавця</span>
      </v-btn>
    </div>

    <b-section-loader :loading="$loading.isLoading('incidentExecutorList')">
      <div v-if="executors.length" class="d-flex flex-column ga-2">
        <v-card v-for="executor in executors" :key="executor.id" border>
          <v-card-text class="d-flex align-center justify-space-between pa-3">
            <div class="d-flex align-center ga-3">
              <user-avatar
                v-if="executor.executor"
                :user="executor.executor"
                size="36"></user-avatar>
              <v-avatar v-else class="bg-grey-lighten-3" size="36">
                <v-icon icon="mdi-account-outline"></v-icon>
              </v-avatar>
              <div>
                <div class="font-weight-bold">
                  {{ getPersonName(executor.executor) || 'Користувач' }}
                </div>
                <div class="text-disabled font-size-12">
                  {{ executor.executor?.role?.name || 'Роль не вказано' }}
                </div>
              </div>
            </div>

            <v-btn
              v-if="canDeleteIncidentExecutor"
              :loading="
                $loading.isLoading(`incidentExecutorDelete_${executor.id}`)
              "
              color="error"
              density="comfortable"
              variant="text"
              @click="deleteIncidentExecutor(executor)">
              <v-icon class="mr-1" icon="mdi-delete-outline"></v-icon>
              Видалити
            </v-btn>
          </v-card-text>
        </v-card>
      </div>

      <div v-else class="d-flex flex-column align-center py-12">
        <search-icon class="mb-5"></search-icon>
        <h2 class="mb-3">Виконавців не призначено</h2>
        <div class="font-size-14">
          Додайте користувачів, відповідальних за роботи в межах інциденту.
        </div>
      </div>
    </b-section-loader>
  </v-card-text>
</template>

<script setup lang="ts">
import { BSectionLoader } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils/helpers'
import SearchIcon from '@/assets/images/SearchIcon.vue'
import UserAvatar from '@/components/UserAvatar.vue'
import { useIncident } from '../Incident'

defineOptions({
  name: 'IncidentExecutors',
})

const {
  canCreateIncidentExecutor,
  canDeleteIncidentExecutor,
  deleteIncidentExecutor,
  executors,
  openIncidentExecutorDialog,
} = useIncident()
</script>
